// ────────────────────────────────────────────────────────────────────────────
// Band list operations. Split out of the retired localStorage store so nothing
// about editing a layout depends on where layouts are saved.
// ────────────────────────────────────────────────────────────────────────────
import { createBand } from './stockTemplates';
import type { BandKind, DocumentLayout } from './types';

/** Band kinds an operator can add more than one of. */
export const REPEATABLE_BAND_KINDS: BandKind[] = ['text'];

function newId(): string {
  return (
    globalThis.crypto?.randomUUID?.() ??
    `band-${Date.now()}-${Math.random().toString(16).slice(2)}`
  );
}

/**
 * Add a band of `kind` immediately before the footer, or at the end when there
 * is none — a new text block belongs in the body, never after the page footer.
 */
export function appendBand(layout: DocumentLayout, kind: BandKind): DocumentLayout {
  const band = createBand(kind, newId());
  const footerIndex = layout.bands.findIndex((b) => b.kind === 'footer');
  const bands = [...layout.bands];
  bands.splice(footerIndex === -1 ? bands.length : footerIndex, 0, band);
  return { ...layout, bands };
}

/** The layout a document of this kind prints with: the default, else the first. */
export function selectDefaultOf<T extends { isDefault: boolean }>(items: T[]): T | undefined {
  return items.find((i) => i.isDefault) ?? items[0];
}
